import { ProviderEditDialogComponent } from './providers/dialogs/provider-edit-dialog.component';
import { SendComponent } from './send/send.component';
import { LogsComponent } from './logs/logs.component';

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProvidersComponent } from './providers/providers.component';
import { AllSmsMessagesComponent } from './all-sms-messages/all-sms-messages.component';
import { AllSmsMessagesDialogComponent } from './all-sms-messages/dialogs/all-sms-messages-dialog.component';
import { WebPushMessagesComponent } from './web-push-messages/web-push-messages.component';
import { ProviderCredentialsEditDialogComponent } from './providers/dialogs/provider-credentials-edit/provider-credentials-edit.component';
import { ProviderPermissionsEditDialogComponent } from './providers/dialogs/provider-permissions-edit/provider-permissions-edit.component';
import { ProviderCredentialSettingsDialogComponent } from './providers/dialogs/provider-credential-settings/provider-credential-settings.component';
import { ProviderCredentialsSettingsEditDialogComponent } from './providers/dialogs/provider-credential-settings-edit/provider-credentials-settings-edit.component';
import { SendMessageHistoriesComponent } from './send/send-message-histories/send-message-histories.component';
import { SendMessageTabComponent } from './send/send-message-tab/send-message-tab.component';
import { SendSmsTabComponent } from './send/send-sms-tab/send-sms-tab.component';
import { AppPermissionKeys } from '@core/models/app-permissions.model';

const routes: Routes = [
  {
    path: 'all-messages',
    component: AllSmsMessagesComponent,
    data: { permissions: AppPermissionKeys.view_all_messages }
  },
  {
    path: 'logs',
    component: LogsComponent,
    data: { permissions: AppPermissionKeys.view_all_smses }
  },
  {
    path: 'send',
    component: SendComponent,
    data: { permissions: AppPermissionKeys.view_send_message }
  },
  {
    path: 'web-push',
    component: WebPushMessagesComponent,
    data: { permissions: AppPermissionKeys.view_web_push_messages_list }
  },
  {
    path: 'providers',
    component: ProvidersComponent,
    data: { permissions: [AppPermissionKeys.view_sms_providers, AppPermissionKeys.view_credentials, AppPermissionKeys.view_sms_provider_permissions] }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  entryComponents: [
    ProviderEditDialogComponent,
    AllSmsMessagesDialogComponent,
    ProviderCredentialsEditDialogComponent,
    ProviderPermissionsEditDialogComponent,
    ProviderCredentialSettingsDialogComponent,
    ProviderCredentialsSettingsEditDialogComponent,
    SendMessageHistoriesComponent,
    SendMessageTabComponent,
    SendSmsTabComponent
  ]
})
export class SmsRoutingModule { }
